// =============================================
// Seleção de Produtos — Área do Cliente
// =============================================
(function () {
  "use strict";

  var $page = $("#prod-page");
  if ($page.length === 0) return;

  // --- Configuração ---
  var apiUrl = $page.data("api");
  var siteUrl = $page.data("url");

  // --- Estado ---
  var currentPage = 1;
  var isLoading = false;
  var hasMore = true;
  var activeCategory = parseInt($page.data("initial-cat")) || 0;
  var debounceTimer = null;

  var localStorageKey = "laserena_selected_products";
  var selectedProducts = {}; // { categoria_id: { id, titulo, valor, foto, estoque, ... } }
  try {
    var saved = localStorage.getItem(localStorageKey);
    if (saved) {
      selectedProducts = JSON.parse(saved);
    }
  } catch (e) {
    console.error("Erro ao carregar localStorage", e);
  }

  // --- Elementos ---
  var $grid = $("#prod-grid");
  var $loading = $("#prod-loading");
  var $empty = $("#prod-empty");
  var $resultsInfo = $("#prod-results-info");
  var $resultsText = $("#prod-results-text");
  var $totalValue = $("#prod-total-value");
  var $main = $("#prod-main");
  var $sidebar = $("#prod-sidebar");

  // --- Filtros ---
  var $busca = $("#prod-filter-busca");
  var $marca = $("#prod-filter-marca");
  var $qtd = $("#prod-filter-qtd");
  var $ordenar = $("#prod-filter-ordenar");

  // =============================================
  // CARREGAR PRODUTOS (AJAX)
  // =============================================
  function loadProducts(reset) {
    if (isLoading) return;
    if (!reset && !hasMore) return;

    if (reset) {
      currentPage = 1;
      hasMore = true;
      $grid.empty();
      $empty.hide();
    }

    isLoading = true;
    $loading.removeClass("hidden").show();

    var params = {
      page: currentPage,
      categoria: activeCategory,
      marca: $marca.val() || "",
      busca: $busca.val() || "",
      qtd_estoque: $qtd.val() || "",
      ordenar: $ordenar.val() || "",
    };

    $.ajax({
      url: apiUrl,
      type: "GET",
      data: params,
      dataType: "json",
    })
      .done(function (resp) {
        isLoading = false;

        if (resp.products && resp.products.length > 0) {
          renderProducts(resp.products);
          hasMore = resp.hasMore;
          currentPage++;
          $empty.hide();
        } else {
          hasMore = false;
          if (currentPage === 1) {
            $empty.show();
          }
        }

        if (!hasMore) {
          $loading.addClass("hidden").hide();
        } else {
          $loading.removeClass("hidden").show();
        }

        // Info de resultados
        $resultsText.empty();
        var strong = document.createElement("strong");
        strong.textContent = resp.total;
        $resultsText.append(strong);
        $resultsText.append(document.createTextNode(" produto(s) encontrado(s)"));
      })
      .fail(function () {
        isLoading = false;
        $loading.addClass("hidden").hide();
      });
  }

  // =============================================
  // RENDERIZAR CARDS DE PRODUTO
  // =============================================
  function renderProducts(products) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var isSelected = selectedProducts[p.categoria_id] && selectedProducts[p.categoria_id].id === p.id;

      // Card container
      var card = document.createElement("div");
      card.className = "prod-card" + (isSelected ? " selected" : "");
      card.setAttribute("data-id", p.id);
      card.setAttribute("data-cat", p.categoria_id);
      card.setAttribute("data-valor", p.valor);
      card.setAttribute("data-titulo", p.titulo);
      card.setAttribute("data-foto", p.foto);
      card.setAttribute("data-cat-titulo", p.categoria_titulo);
      card.setAttribute("data-estoque", p.estoque);

      // Imagem
      var figure = document.createElement("figure");
      figure.className = "prod-card-img";

      var img = document.createElement("img");
      img.src = p.foto;
      img.alt = p.titulo;
      figure.appendChild(img);

      // Badge da marca
      if (p.marca_logo) {
        var brandSpan = document.createElement("span");
        brandSpan.className = "prod-card-brand";
        var brandImg = document.createElement("img");
        brandImg.src = p.marca_logo;
        brandImg.alt = p.marca_titulo;
        brandSpan.appendChild(brandImg);
        figure.appendChild(brandSpan);
      }

      card.appendChild(figure);

      // Info
      var info = document.createElement("div");
      info.className = "prod-card-info";

      var title = document.createElement("h3");
      title.className = "prod-card-title";
      title.textContent = p.titulo;
      info.appendChild(title);

      var price = document.createElement("div");
      price.className = "prod-card-price";
      price.textContent = "R$ " + p.valor_fmt;
      info.appendChild(price);

      var stock = document.createElement("div");
      stock.className = "prod-card-stock";

      var stockIcon = document.createElement("i");
      stockIcon.className = "las la-box";
      stock.appendChild(stockIcon);
      stock.appendChild(document.createTextNode(" Estoque: " + p.estoque + " un."));
      info.appendChild(stock);

      // Botão selecionar
      var btn = document.createElement("button");
      btn.className = "btn btn-sm prod-card-select " + (isSelected ? "btn-primario" : "btn-primario outline");
      btn.textContent = isSelected ? "Selecionado" : "Selecionar";
      info.appendChild(btn);

      card.appendChild(info);
      $grid.append(card);
    }
  }

  // =============================================
  // SCROLL INFINITO
  // =============================================
  function setupScrollObserver() {
    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting && !isLoading && hasMore) {
            loadProducts(false);
          }
        },
        { rootMargin: "200px" }
      );
      observer.observe($loading[0]);
    } else {
      // Fallback para scroll
      $(window).on("scroll.prodInfinite", function () {
        if (isLoading || !hasMore) return;
        var scrollBottom = $(window).scrollTop() + $(window).height();
        var loadingTop = $loading.offset().top;
        if (scrollBottom >= loadingTop - 200) {
          loadProducts(false);
        }
      });
    }
  }

  // =============================================
  // SELEÇÃO DE PRODUTO
  // =============================================
  $grid.on("click", ".prod-card-select", function (e) {
    e.stopPropagation();
    var $card = $(this).closest(".prod-card");
    selectProduct($card);
  });

  $grid.on("click", ".prod-card", function () {
    selectProduct($(this));
  });

  function saveToLocalStorage() {
    try {
      localStorage.setItem(localStorageKey, JSON.stringify(selectedProducts));
    } catch (e) {
      console.error("Erro ao salvar no localStorage", e);
    }
  }

  function selectProduct($card) {
    var prodId = parseInt($card.data("id"));
    var catId = parseInt($card.data("cat"));
    var valor = parseFloat($card.data("valor"));
    var titulo = $card.data("titulo");
    var foto = $card.data("foto");
    var catTitulo = $card.data("cat-titulo");
    var estoque = parseInt($card.data("estoque"));

    // Se o mesmo produto já está selecionado, desseleciona
    if (selectedProducts[catId] && selectedProducts[catId].id === prodId) {
      removeSelection(catId);
      $page.removeClass("show-products");
      return;
    }

    // Remove seleção anterior da mesma categoria (visual nos cards)
    $grid.find('.prod-card[data-cat="' + catId + '"]').each(function () {
      $(this).removeClass("selected");
      $(this).find(".prod-card-select")
        .removeClass("btn-primario")
        .addClass("btn-primario outline")
        .text("Selecionar");
    });

    // Seleciona o novo produto
    $card.addClass("selected");
    $card.find(".prod-card-select")
      .removeClass("outline")
      .addClass("btn-primario")
      .text("Selecionado");

    // Salva no estado
    selectedProducts[catId] = {
      id: prodId,
      titulo: titulo,
      valor: valor,
      foto: foto,
      catTitulo: catTitulo,
      estoque: estoque,
    };

    saveToLocalStorage();

    // Atualiza o slot no resumo
    updateSummarySlot(catId);
    updateTotal();

    // Mobile: ao selecionar, volta a exibir o resumo e oculta a lista de produtos
    $page.removeClass("show-products");
  }

  // =============================================
  // RESUMO DO PEDIDO
  // =============================================
  function updateSummarySlot(catId) {
    var $slot = $("#prod-slot-" + catId);
    var product = selectedProducts[catId];

    if (product) {
      $slot.addClass("filled");
      $slot.find(".prod-slot-placeholder").hide();
      var $selected = $slot.find(".prod-slot-selected");
      $selected.show();
      $selected.find(".prod-slot-selected-img img").attr("src", product.foto).attr("alt", product.titulo);
      $selected.find(".prod-slot-prod-name").text(product.titulo);
      $selected.find(".prod-slot-prod-price").text(formatCurrency(product.valor));
      $selected.find(".prod-slot-prod-stock").text("Estoque: " + (product.estoque || 0) + " un.");
    } else {
      $slot.removeClass("filled");
      $slot.find(".prod-slot-placeholder").show();
      $slot.find(".prod-slot-selected").hide();
    }
  }

  function updateTotal() {
    var total = 0;
    var count = 0;
    for (var catId in selectedProducts) {
      if (selectedProducts.hasOwnProperty(catId) && selectedProducts[catId]) {
        total += selectedProducts[catId].valor;
        count++;
      }
    }
    $totalValue.text(formatCurrency(total));

    var $btn = $("#prod-btn-personalizar");
    if (count > 0) {
      $btn.removeClass("disabled");
    } else {
      $btn.addClass("disabled");
    }
  }

  function formatCurrency(value) {
    return "R$ " + value.toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  // Remoção de produto do resumo
  $(document).on("click", ".prod-slot-remove", function () {
    var catId = parseInt($(this).data("cat"));
    removeSelection(catId);
  });

  // Impedir navegação no botão de personalização se estiver desativado
  $(document).on("click", "#prod-btn-personalizar", function (e) {
    if ($(this).hasClass("disabled")) {
      e.preventDefault();
      return false;
    }
  });

  function removeSelection(catId) {
    // Remove visual dos cards
    $grid.find('.prod-card[data-cat="' + catId + '"]').each(function () {
      $(this).removeClass("selected");
      $(this).find(".prod-card-select")
        .removeClass("btn-primario")
        .addClass("btn-primario outline")
        .text("Selecionar");
    });

    // Remove do estado
    delete selectedProducts[catId];
    saveToLocalStorage();

    // Atualiza slot
    updateSummarySlot(catId);
    updateTotal();
  }

  // =============================================
  // FILTRO POR CATEGORIA (Sidebar + Resumo)
  // =============================================
  $(document).on("click", ".prod-sidebar-item", function () {
    var catId = parseInt($(this).data("cat"));

    // Atualiza estado ativo na sidebar
    $(".prod-sidebar-item").removeClass("active");
    $(this).addClass("active");

    activeCategory = catId;
    loadProducts(true);

    // Mobile: exibe a lista de produtos (esconde o resumo)
    $page.addClass("show-products");
  });

  // Click no "Selecionar" do placeholder no resumo = filtro
  $(document).on("click", ".prod-slot-select-btn", function () {
    var catId = parseInt($(this).data("cat"));

    // Ativa a categoria na sidebar
    $(".prod-sidebar-item").removeClass("active");
    $('.prod-sidebar-item[data-cat="' + catId + '"]').addClass("active");

    activeCategory = catId;
    loadProducts(true);

    // Mobile: exibe a lista de produtos (esconde o resumo)
    $page.addClass("show-products");
  });

  // =============================================
  // FILTROS (Busca, Marca, Qtd, Ordenação)
  // =============================================
  $busca.on("input", function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      loadProducts(true);
    }, 500);
  });

  $marca.on("change", function () {
    loadProducts(true);
  });

  $qtd.on("change", function () {
    loadProducts(true);
  });

  $ordenar.on("change", function () {
    loadProducts(true);
  });

  // =============================================
  // MOBILE: Botão voltar
  // =============================================
  $("#prod-main-back").on("click", function () {
    $page.removeClass("show-products");
  });

  // =============================================
  // INICIALIZAÇÃO
  // =============================================
  // Preencher slots pré-salvos se existirem no localStorage
  for (var catId in selectedProducts) {
    if (selectedProducts.hasOwnProperty(catId) && selectedProducts[catId]) {
      updateSummarySlot(catId);
    }
  }
  updateTotal();

  loadProducts(true);
  setupScrollObserver();
})();
